import {z} from '@hono/zod-openapi';

/** `POST /bulk` answers `text/csv`: one row per item, no header row. */
export const priceReportBulkCsvResponseSchema = z.string().openapi('PriceReportBulkCsvResponse');
